<template>
    <div>
        <div class="text-center text-danger my-2" v-if="loading">
            <b-spinner class="align-middle"></b-spinner>
             <strong>Chargement des données…</strong>
        </div>
        <div v-else>
            <h1 v-if="form.id">Édition d'un matériel</h1>
            <h1 v-else>Ajout d'un matériel</h1>
            <b-row class="justify-content-center">
                <b-col cols=" 12" md="6">
                    <b-form @submit.prevent.stop="onSubmit" ref="form">
                        <input type="hidden" name="id" :value="form.id" v-if="!!id"/>
                        <b-alert variant="danger" :show="errors.length > 0">
                            <p class="mb-0" v-for="error in errors" v-bind:key="error">{{error}}</p>
                        </b-alert>
                        <b-form-group label="Numéro de série" description="Numéro de série du matériel de la forme ZZZ-ZZ.X123456789Y figurant sur l'étiquette présente sur le produit" label-for="deviceSerial">
                            <b-form-input id="deviceSerial" type="text" v-model="form.deviceSerial" required :disabled="!!id"/>
                        </b-form-group>
                        <b-form-group label="Numéro de série passerelle" description="Numéro de série de la passerelle de la forme REP-4G.X123456789Y figurant sur l'étiquette présente sur la passerelle" label-for="gatewaySerial">
                            <v-select :options="gateways" taggable id="gatewaySerial" :disabled="!!id" v-model="form.gatewaySerial">
                                <template #search="{attributes, events}">
                                    <input
                                            class="vs__search"
                                            :required="!form.gatewaySerial"
                                            v-bind="attributes"
                                            v-on="events"
                                    />
                                </template>
                            </v-select>
                        </b-form-group>
                        <b-form-group label="Intitulé" description="Intitulé du matériel dans les différents listings" label-for="label">
                            <b-form-input id="label" type="text" v-model="form.label" required/>
                        </b-form-group>
                        <div class="text-center">
                            <b-button type="submit" variant="primary" :disabled="processing" v-if="!!id">Valider</b-button>
                            <b-button type="submit" variant="primary" :disabled="processing" v-else>Ajouter</b-button>
                        </div>
                    </b-form>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import {API_URL} from "../../variables";

    export default {
        name: "DeviceForm",
        props: ["id"],
        data() {
            return {
                form: {
                    id: null,
                    deviceSerial: "",
                    gatewaySerial: "",
                    label: ""
                },
                errors: [],
                loading: true,
                processing: false
            };
        },
        mounted() {
            this.form.id = this.id;
            let requests = [];

            requests.push(axios
                .get(API_URL + "/user/gateways")
                .then(response => this.gateways = response.data.map(gateway => gateway.serial)));
            if (this.form.id) {
                requests.push(axios
                    .get(API_URL + "/user/device/info", {params: {id: this.form.id}})
                    .then(response => this.form = response.data));
            }
            axios.all(requests)
                .then(axios.spread(() => this.loading = false));
        },
        methods: {
            onSubmit() {
                this.processing = true;
                this.errors = [];
                axios
                    .post(API_URL + (this.form.id ? "/user/device/update" : "/user/device/register"), this.form)
                    .then(response => {
                        if (response.data.success) {
                            this.$router.push("/devices");
                        } else {
                            this.errors.push(response.data.error);
                        }
                    })
                    .catch(() => {
                        this.errors.push("Une erreur est survenue durant le traitement de votre requête, veuillez réessayer ultérieurement");
                    })
                    .finally(() => {
                        this.processing = false;
                    });
            }
        }
    }
</script>